import { Component, OnInit } from '@angular/core';
import { ShoopingService } from '../shooping.service';
import { Products } from '../shooping.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  products: Products[] = [];
  favProduct = [];
  categories:any;


  constructor(private shoopingService: ShoopingService, private spinnerService: NgxSpinnerService, private notifyService : NotificationService) { }

  ngOnInit(): void {
    this.showSpinner();
    this.fetchProductLimit();
    this.getCategory();
    this.getFavProducts();
  }

  fetchProductLimit() {
    this.shoopingService.getProductLimit(8).subscribe(res => {
      res.forEach(item => item.price = Math.floor(item.price));
      this.products = res;
    });
  }

  getFavProducts() {
    let findCart = localStorage.getItem('favProduct');
    if(!findCart) {
      localStorage.setItem('favProduct',JSON.stringify([]));
    }
    this.favProduct = JSON.parse(localStorage.getItem('favProduct'));
  }

  public showSpinner(): void {
    this.spinnerService.show();
    if(this.products.length > 0){
      this.spinnerService.hide();
    }
  }

  addFavourite(product){
    this.checkFavourite(product);
    localStorage.setItem('favProduct', JSON.stringify(this.favProduct));
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }

  getCategory() {
    this.shoopingService.getCategories().subscribe(res => {
      this.categories = res;
    })
  }

  checkImage(category) {
    if(category == 'electronics') {
      return '../assets/electronics.jpg';
    } else if(category == 'jewelery') {
      return '../assets/jewelery.jpg';
    } else if(category == "men's clothing") {
      return '../assets/mens_clothing.jpg';
    } else if(category == "women's clothing") {
      return '../assets/womens_clothing.jpg';
    }
  }

  checkFavourite(product) {
    let findProduct = this.favProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.favProduct.push(product);
      this.showToasterSuccess('Product added in the Favourite List!');
    } else {
      let removeProduct = this.favProduct.filter(item => item.id !== product.id);
      this.favProduct = removeProduct;
      this.showToasterSuccess('Product removed in the Favourite List!');
    }
  }
}
